import { Routes } from '@angular/router';
import { PricesListComponent } from './prices-list/prices-list.component';
import { PriceFormComponent } from './price-form/price-form.component';

export const PRICES_ROUTES: Routes = [
  {
    path: 'price-configuration',
    component: PricesListComponent
  },
  {
    path: 'price-configuration/new',
    component: PriceFormComponent
  },
  {
    path: 'price-configuration/edit/:id',
    component: PriceFormComponent
  }
];
